module.exports = __webpack_public_path__ + "img/logo-top-menu.06b03884.png";